import isArray from './is-array';
import { default as getMax } from './max';
import { default as getMin } from './min';
var getRange = function (values) {
    // å­å¨ NaN æ¶ï¼min,max å¤å®ä¼åºé®é¢
    var filterValues = values.filter(function (v) { return !isNaN(v); });
    if (!filterValues.length) {
        // å¦ææ²¡ææ°å¼åç´æ¥è¿å0
        return {
            min: 0,
            max: 0,
        };
    }
    if (isArray(values[0])) {
        var tmp = [];
        for (var i = 0; i < values.length; i++) {
            tmp = tmp.concat(values[i]);
        }
        filterValues = tmp;
    }
    var max = getMax(filterValues);
    var min = getMin(filterValues);
    return {
        min: min,
        max: max,
    };
};
export default getRange;
//# sourceMappingURL=get-range.js.map